export function formatNumberInput(
  value: string,
  allowDecimals: boolean,
  allowNegative: boolean,
  precision?: number | null,
): string {
  let val = value ?? "";

  // --- Máscara tipo banco (RTL) cuando hay decimales y precision 1..4 ---
  const isMaskedRTL =
    allowDecimals === true &&
    typeof precision === "number" &&
    precision >= 1 &&
    precision <= 4;

  if (isMaskedRTL) {
    // Detectar signo al inicio si se permite
    const hadMinus = allowNegative && /^-/.test(val);

    // Tomar solo dígitos del input (ignoramos puntos o guiones intermedios)
    const digits = (val.match(/\d+/g) || []).join("");

    if (digits.length === 0) {
      // Permitir vaciar el campo
      return hadMinus ? "-" : "";
    }

    // Colocar la coma/punto automáticamente desde la derecha
    let intPart = "0";
    let fracPart = digits;

    if (digits.length > precision) {
      intPart = digits.slice(0, -precision);
      fracPart = digits.slice(-precision);
    } else {
      // Rellenar con ceros a la izquierda para mantener la precisión
      fracPart = digits.padStart(precision, "0");
    }

    // Evitar ceros a la izquierda innecesarios en la parte entera
    intPart = intPart.replace(/^0+(?=\d)/, "");

    const formatted = `${intPart}.${fracPart}`;
    return hadMinus ? `-${formatted}` : formatted;
  }

  // --- Modo normal (LTR) ---
  if (allowDecimals && allowNegative) {
    // Permitir '-' solo al inicio y un solo '.'
    // eslint-disable-next-line no-useless-escape
    val = val.replace(/[^0-9.\-]/g, "");
    val = val.replace(/(?!^)-/g, "");
    const parts = val.split(".");
    if (parts.length > 2) {
      val = parts[0] + "." + parts.slice(1).join("");
    }
    // Si precision === 0, forzar entero (aunque allowDecimals sea true)
    if (precision === 0 && val.includes(".")) {
      val = parts[0];
    }
    return val;
  } else if (allowDecimals) {
    // Decimales positivos
    val = val.replace(/[^0-9.]/g, "");
    const parts = val.split(".");
    if (parts.length > 2) {
      val = parts[0] + "." + parts.slice(1).join("");
    }
    if (precision === 0 && val.includes(".")) {
      val = parts[0];
    }
    return val;
  } else if (allowNegative) {
    // Solo enteros con signo
    val = val.replace(/[^0-9-]/g, "");
    val = val.replace(/(?!^)-/g, "");
    return val;
  } else {
    // Solo enteros positivos
    return val.replace(/\D/g, "");
  }
}
